import React, { useState, useRef, useEffect, useCallback } from 'react'
import AdminApi from '../../../../api/admin-api/admin-api'

const AgentTypeahead = ({ onSelect, placeholder }) => {
  const [query, setQuery] = useState('')
  const [results, setResults] = useState([])
  const [loading, setLoading] = useState(false)
  const [showDropdown, setShowDropdown] = useState(false)
  const debounceRef = useRef(null)
  const wrapperRef = useRef(null)

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = e => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowDropdown(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const searchAgents = useCallback(async term => {
    if (!term || term.trim().length < 2) {
      setResults([])
      setShowDropdown(false)
      return
    }

    setLoading(true)
    try {
      const response = await AdminApi.getUsersFromSearchTerm(term.trim())
      const agents = response?.data?.data || response?.data || []
      setResults(Array.isArray(agents) ? agents.slice(0, 15) : [])
      setShowDropdown(true)
    } catch (err) {
      console.error('Agent search error:', err)
      setResults([])
    }
    setLoading(false)
  }, [])

  const handleChange = e => {
    const val = e.target.value
    setQuery(val)

    if (debounceRef.current) clearTimeout(debounceRef.current)
    debounceRef.current = setTimeout(() => searchAgents(val), 350)
  }

  const handleSelect = agent => {
    onSelect({
      user_id: agent.id,
      u_name: agent.u_fullname || `${agent.u_fname || ''} ${agent.u_lname || ''}`.trim(),
      u_fname: agent.u_fname,
      u_lname: agent.u_lname,
      u_email: agent.u_email,
    })
    setQuery('')
    setResults([])
    setShowDropdown(false)
  }

  return (
    <div ref={wrapperRef} className='agent-typeahead' style={{ position: 'relative' }}>
      <input
        type='text'
        className='form-control'
        placeholder={placeholder || 'Search agent by name...'}
        value={query}
        onChange={handleChange}
        onFocus={() => results.length > 0 && setShowDropdown(true)}
      />
      {loading && (
        <small className='text-muted' style={{ position: 'absolute', right: 10, top: 10 }}>
          Searching...
        </small>
      )}
      {showDropdown && results.length > 0 && (
        <ul className='typeahead-dropdown'>
          {results.map(agent => (
            <li key={agent.id} className='typeahead-item' onClick={() => handleSelect(agent)}>
              <strong>{agent.u_fullname || `${agent.u_fname} ${agent.u_lname}`}</strong>
              <span className='text-muted ml-2'>
                (ID: {agent.id}){agent.u_email ? ` — ${agent.u_email}` : ''}
              </span>
            </li>
          ))}
        </ul>
      )}
      {showDropdown && !loading && query.length >= 2 && results.length === 0 && (
        <ul className='typeahead-dropdown'>
          <li className='typeahead-item text-muted'>No agents found</li>
        </ul>
      )}
    </div>
  )
}

export default AgentTypeahead
